import React from 'react'
import ResumeCard from './ResumeCard'
import {motion} from 'framer-motion'

const Education = () => {
  return (
    <motion.div initial = {{opacity:0 }} animate = {{opacity:1, transition:{duration:.5}}} 
    className='w-full flex gap-20'>
    <div>
    <div className='py-12 font-titleFont gap-4'>
        <p className='text-sm text-designColor tracking-[4px]'>2018-Now</p>
        <h2 className='text-4xl font-bold'>Education Quality</h2>
    </div>
    <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
      <ResumeCard
        title="B.Eng Computer Engineering"
        subTitle="Chulalongkorn University (2024 - NOW)"
        result="Studying"
        // des="This program provides the studies in basic science-mathematics, computer science and engineering principles (Analysis, Design, Organization and Implementation)"
      />
      <ResumeCard
        title="Technology Excelent Program"
        subTitle="The Prince Royal’s College (2021 - 2024)"
        result="3.47 / 4"
        // des="Higher education is tertiary education leading to award of an academic degree. Higher education, also called post-secondary education."
      />
      <ResumeCard
        title="Science & Mathematics Excelent Program"
        subTitle="The Prince Royal’s College (2018 - 2021)"
        result="3.80 / 4"
        // des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
      />
    </div>
    </div>
    <div>
    <div className='py-12 font-titleFont gap-4'>
        <p className='text-sm text-designColor tracking-[4px]'>2022-Now</p>
        <h2 className='text-4xl font-bold'>Extracurricular Class</h2>
    </div>
    <div className="mt-6 lgl:mt-14 w-full h-[1400px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
      <ResumeCard
        title="Master Power BI for Business Intelligence"
        subTitle="Udemy (December 2024)"
        result="Success"
        // des="The training provided by universities in order to prepare people to work in various sectors of the economy or areas of culture."
      />
      <ResumeCard
        title="The Ultimate MySQL Bootcamp Expert"
        subTitle="Udemy (December 2024)"
        result="Success"
        // des="Higher education is tertiary education leading to award of an academic degree. Higher education, also called post-secondary education."
      />
      <ResumeCard
        title="Investment Risk Management"
        subTitle="Coursera (December 2024)"
        result="Success"
        // des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
      />
        <ResumeCard
        title="Data Analysis using Microsoft Excel"
        subTitle="Coursera (November 2024)"
        result="Success"
        // des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
      />
        <ResumeCard
        title="Business Analysis & Process Management"
        subTitle="Coursera (December 2024)"
        result="Success"
        // des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
      />
      
    </div>
    </div>
    </motion.div>
  )
}

export default Education